import tr from './tr/common';
import en from './en/common';

const messages = {
  tr: {
    translation: tr,
  },
  en: {
    translation: en,
  },
};

export default messages;
